import { ApiClient } from './client';

const ADMIN_BASE_URL = 'https://' + import.meta.env.VITE_BACKEND_CUSTOM_DOMAIN_NAME + '/api-bf/';

export const loginApi = new ApiClient(ADMIN_BASE_URL);
